/*       */

import { gql } from '@apollo/client';

export default gql`
    query loadTeamsTypeaheadPermissionsQuery($startIndex: Int, $stopIndex: Int, $filterBy: [JSON], $orderBy: [JSON], $excludeBy: [JSON]) {
        result: teams(startIndex: $startIndex, stopIndex: $stopIndex, filterBy: $filterBy, orderBy: $orderBy, excludeBy: $excludeBy) {
            id
            name
            __typename
        }
    }
`;
